import { fetchWithAuth } from '../utils/tokenRefresh';
import { getApiEndpoint } from '../config/apiEndpoints';
import { Game, GameSummary, GuessEntry, DictionaryInfo } from '../types';

export class ApiError extends Error {
  status: number;
  constructor(status: number, message: string) {
    super(message);
    this.status = status;
  }
}

async function parseJson(response: Response) {
  const data = await response.json();
  if (!response.ok) {
    throw new ApiError(response.status, data.error || 'Request failed');
  }
  return data;
}

export async function createGame(difficulty: 'basic' | 'hard'): Promise<Game> {
  const response = await fetchWithAuth(getApiEndpoint('/games'), {
    method: 'POST',
    body: JSON.stringify({ difficulty }),
  });

  const data = await parseJson(response);
  return data.game as Game;
}

export async function submitGuess(gameId: string, guess: string): Promise<{ game: Game; latest_guess: GuessEntry }>{
  const response = await fetchWithAuth(getApiEndpoint(`/games/${gameId}/guess`), {
    method: 'POST',
    body: JSON.stringify({ guess }),
  });

  return parseJson(response);
}

export async function listGames(limit: number = 20): Promise<GameSummary[]> {
  const response = await fetchWithAuth(getApiEndpoint(`/games?limit=${limit}`));
  const data = await parseJson(response);
  return data.games as GameSummary[];
}

export async function getGame(gameId: string): Promise<Game> {
  const response = await fetchWithAuth(getApiEndpoint(`/games/${gameId}`));
  const data = await parseJson(response);
  return data.game as Game;
}

export async function getWordInfo(word: string): Promise<DictionaryInfo | null> {
  try {
    const response = await fetchWithAuth(getApiEndpoint(`/words/${encodeURIComponent(word)}`));
    const data = await parseJson(response);
    return data.info as DictionaryInfo;
  } catch {
    return null;
  }
}
